import { render } from "./ActionsCards.vue?vue&type=template&id=1f1a8fb4"
import script from "./ActionsCards.vue?vue&type=script&lang=js"
export * from "./ActionsCards.vue?vue&type=script&lang=js"

import "./ActionsCards.vue?vue&type=style&index=0&id=1f1a8fb4&lang=scss"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__